import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.js';
import { AuthProvider } from './auth/AuthContext.js';
import { BrandProvider } from './branding/BrandProvider.js';
import { ToastProvider } from './components/Toast.js';

import './styles/theme.css';
import './styles/app.css';
import './styles/whitelabel.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      {/* Outermost of the three, because the login screen is inside AuthProvider and has to
          be branded too: an operator signing in to someone else's product is the exact
          impression this removes. */}
      <BrandProvider>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </BrandProvider>
    </BrowserRouter>
  </StrictMode>,
);
